package com.fireavert.invite.data_models.exceptions

class PasswordsDoNotMatchException: Exception("Passwords do not match") {
}